export const ACCEPTED_EXTENSIONS = ['csv', 'xls', 'xlsx', 'pdf', 'jpg', 'png', 'txt']
export const DEFAULT_MAX_FILES = 1
